module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/template-designer/template-designer.component.scss
// module id = ./src/app/template-designer/template-designer.component.scss
// module chunks = main